(function () {
  const SECTION_SELECTOR = '.it-final-block';
  const TITLE_SELECTOR = '.final-block__title';
  const TYPE_SPEED = 85;

  function prepareTypedSpan(section) {
    const title = section.querySelector(TITLE_SELECTOR);

    if (!title) {
      return null;
    }

    const span = title.querySelector('span');

    if (!span) {
      return null;
    }

    const source = span.textContent || '';

    if (!source) {
      return null;
    }

    span.dataset.typedSource = source;
    span.innerHTML = '';

    return span;
  }

  function typeSpan(span) {
    if (!span || span.dataset.typedStarted === 'true') {
      return;
    }

    const source = span.dataset.typedSource || '';

    if (!source) {
      return;
    }

    span.dataset.typedStarted = 'true';

    let charIndex = 0;

    function tick() {
      charIndex += 1;
      span.textContent = source.slice(0, charIndex);

      if (charIndex < source.length) {
        window.setTimeout(tick, TYPE_SPEED);
      }
    }

    tick();
  }

  function initSection(section) {
    const fadeElements = section.querySelectorAll('.fade-up');
    const typedSpan = prepareTypedSpan(section);

    if (!fadeElements.length) {
      return;
    }

    section.classList.add('is-reveal-ready');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }

        entry.target.classList.add('is-visible');

        if (entry.target.classList.contains('final-block__media')) {
          entry.target.classList.add('is-lines-visible');
        }

        if (typedSpan && entry.target.matches(TITLE_SELECTOR)) {
          window.setTimeout(() => {
            typeSpan(typedSpan);
          }, 180);
        }

        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.18,
      rootMargin: '0px 0px -8% 0px',
    });

    fadeElements.forEach((element, index) => {
      element.style.transitionDelay = `${index * 110}ms`;
      observer.observe(element);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(SECTION_SELECTOR).forEach((section) => {
      initSection(section);
    });
  });
})();
